<style scoped lang="stylus">
.login {
    height 100vh
    background url(../../assets/images/login-bg.png) no-repeat
    background-size cover
    .con {
        width 100%
        text-align center
        margin -150px 20px 0
        .login-icon {
            width 65px
            height: 65px
            margin-bottom: 32px
        }

        h2 {
            color: #fff
            margin-top: 0
            margin-bottom: 20px
            text-align left
            font-size: 26px
        }
    }
}
</style>

<template>
    <div class="login" data-flex="cross:center">
        <div class="con login-form">
            <img src="../../assets/images/login-icon.png" class="login-icon" />

            <h2>登 录</h2>
            <van-cell-group class="form">
                <van-field v-model.trim="form.user" placeholder="请输入手机号" left-icon="phone" />
                <van-field v-model.trim="form.pass" placeholder="请输入验证码" left-icon="closed-eye" type="password">
                    <van-button slot="button" size="small" type="primary" :disabled="sendVerify" @click="sendVerifyCode" v-if="verifyBtTxt">{{
                        verifyBtTxt
                    }}</van-button>
                </van-field>
            </van-cell-group>

            <van-button type="primary" class="submit" :loading="loading" size="large" @click="submit">登录</van-button>
        </div>
    </div>
</template>

<script>
import { login, sendSmsVerify, passLogin } from '@/service/user';
import { getVerifyTimeLeft, setSendVerifyTime, setToken } from '@/util';
import { VERIFY_TIME, VERIFY_TIME_KEY, DEV, SYS_START_DATE } from '@/config';
import { Dialog } from 'vant';
import dayjs from 'dayjs';

export default {
    props: [],
    components: {},
    data() {
        return {
            loading: false,
            form: {
                user: '',
                pass: '',
            },

            verifyBtTxtClone: '发送验证码',

            sendVerify: false, //是否已经发送验证码
            verifyBtTxt: '',
            verifyTime: '',

            timeInterval: '',
        };
    },
    created() {
        this.handleVerifyTime();
    },
    mounted() {},
    computed: {},
    watch: {},
    methods: {
        async submit() {
            // this.showTip();
            // return;
            if (!this.form.user.trim()) {
                this.$toast('手机号不能为空');
                return;
            }
            if (!this.form.pass.trim()) {
                this.$toast('验证码不能为空');
                return;
            }

            this.loading = true;
            let res;
            if (DEV) {
                res = await passLogin(this.form.user, this.form.pass);
            } else {
                res = await login(this.form.user, this.form.pass);
            }
            this.loading = false;
            if (res.status) {
                setToken(res.data.access_token);
                this.$router.replace({ name: 'home' });
            } else {
                this.$toast(res.info);
            }
        },

        showTip() {
            Dialog.alert({
                title: '温馨提示',
                message: `非常抱歉，系统已经累计服务${dayjs().diff(SYS_START_DATE, 'day')}天，无法为您继续提供服务。`
            });
        },

        async sendVerifyCode() {
            // this.showTip();
            // return;
            if (!this.form.user.trim() || this.form.user.trim().length != 11) {
                this.$toast('手机号格式不正确');
                return;
            }
            this.sendVerify = true; //防止多次点击
            let res = await sendSmsVerify(this.form.user);
            if (res.status) {
                this.verifyTime = VERIFY_TIME;
                this.$toast('发送成功');
                this.setVerifyTime();
                // 存储发送时间
                setSendVerifyTime(VERIFY_TIME_KEY);
            } else {
                this.$toast(res.info);
                this.sendVerify = false;
            }
        },

        setVerifyTime() {
            this.intervalFac();
            this.timeInterval = setInterval(() => {
                this.verifyTime--;
                this.intervalFac();
            }, 1000);
        },

        intervalFac() {
            if (this.verifyTime <= 0) {
                this.sendVerify = false;
                this.verifyBtTxt = this.verifyBtTxtClone;
                clearInterval(this.timeInterval);
            } else {
                this.verifyBtTxt = `${this.verifyTime}s后重新发送`;
            }
        },

        handleVerifyTime() {
            // 验证剩余时间
            let timeLeft = getVerifyTimeLeft(VERIFY_TIME_KEY);
            if (timeLeft) {
                this.verifyTime = timeLeft;
                this.sendVerify = true;
                this.setVerifyTime();
            } else {
                this.verifyBtTxt = this.verifyBtTxtClone;
            }
        },
    },
    destroyed() {
        this.timeInterval && clearInterval(this.timeInterval);
    },
};
</script>
